import styled from 'styled-components';
import { colors } from '../../constants';

export const Line = styled.div`
    height: 2px;
    margin: 48px 24px;
    background-color: ${colors.greyLight};
`;
